__turbopack_context__.v({
  "container": "DNnddG_container",
  "description": "DNnddG_description",
  "errorHint": "DNnddG_errorHint",
  "hint": "DNnddG_hint",
});
